
export const getStepConfig = (step: number, email: string, phone: string) => {
  const configs = {
    1: {
      title: "Let's get started",
      subtitle: "Set up your account in just a few simple steps.",
      type: "",
    },
    2: {
      title: "Contact Information",
      subtitle: "Your email and phone number.",
      type: "",
    },
    3: {
      title: "Set Password",
      subtitle: "Pick something memorable.",
      type: "",
    },
    4: {
      title: "Account Verification",
      subtitle: "Verification codes have been sent to your email and phone.",
      type: "email",
    },
    5: {
      title: "Energy Profile",
      subtitle: "Set up your energy profile to unlock all features.",
      type: "",
    },
    6: {
      title: "Shared Account",
      subtitle: "Invite your team and assign roles.",
      type: "",
    },
    7: {
      title: "Profile Picture",
      subtitle: "Choose an image for your account.",
      type: "",
    },
  };
  return configs[step as keyof typeof configs];
};
